// extracted by mini-css-extract-plugin
export default {"wrapper":"RB","noPadding":"SB","flavor_wrapper":"TB","flavor_button":"UB","vert":"VB","itemContent":"WB","itemName":"XB","blue":"YB","out_of_stock":"ZB","newFlavorBadge":"aC","fullWidth":"bC","flavor_button_selected":"cC","black":"eC","attribute_wrapper":"fC","toggle_wrapper":"gC"};
    if(module.hot) {
      // 1738064241552
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  